// JS actulaiza datos de el carrito de compras y los almacena en localstorage

$(document).ready(function(){
    // variantes

    // acciones
    $('body').on('click', '.js-cart-update__action', function(event) {
        cartUpdate($(this))
    })

    $('body').on('change', '.js-cart-update__action-input', function(event) {
        cartUpdateLine( $(this).data('cart-update__key'), ($(this).val()/1) )
    })

    // funciones
    function cartUpdate(action){
        $('.js-cart-update__input').each( function (){
            if ( action.data('cart-update__id') == $(this).data('cart-update__id') ) {
                cartUpdateLine( $(this).data('cart-update__key'), ($(this).val()/1) )
            }
        })
    }

    function cartUpdateLine(id, num){
        $.ajax({
            url: "/cart/change",
            type: "post",
            data: {
                id: id,
                quantity: num
            },
            dataType: 'json',
            async: false,
            success: res => {
                localStorage.setItem('atom_cart', JSON.stringify(res))
            },
            error: err => {
                console.log(err)
            }
        }) 
    }
})
